import { PDFDocument } from "pdf-lib"
import { useCallback, useState } from "react"

import type { PdfFile } from "./usePdfThumbnails"

export function usePdfMerge() {
  const [processing, setProcessing] = useState(false)
  const [progress, setProgress] = useState(0)
  const [error, setError] = useState<string | null>(null)

  const mergePdfs = useCallback(async (files: PdfFile[]) => {
    setProcessing(true)
    setProgress(0)
    setError(null)

    try {
      const mergedPdf = await PDFDocument.create()
      const totalFiles = files.length

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const arrayBuffer = await file.file.arrayBuffer()
        const pdf = await PDFDocument.load(arrayBuffer)
        const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())

        pages.forEach((page) => mergedPdf.addPage(page))
        setProgress(((i + 1) / totalFiles) * 100)
      }

      const pdfBytes = await mergedPdf.save()
      return new Blob([pdfBytes as BlobPart], { type: "application/pdf" })
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Failed to merge PDFs"
      setError(message)
      throw err
    } finally {
      setProcessing(false)
    }
  }, [])

  return { mergePdfs, processing, progress, error }
}
